<template>
  <el-popover placement="top" trigger="hover">
    <el-tag type="warning">
      <i class="el-icon-info" style="margin-right: 4px"></i>
      {{ getServiceName() }} : {{ getRecordName() }}
    </el-tag>
    <span slot="reference">In Use!</span>
  </el-popover>
</template>

<script>
import feathersClient from "../feathers/feathers-client";

export default {
  name: "InUse",

  props: {
    inUse: {
      required: true
    }
  },

  data() {
    return {
      record: null,
      serviceNames: {
        extensions: "Extension",
        "conference-bridges": "Conference Room",
        huntlists: "Huntlist",
        "paging-groups": "Paging Group",
        flows: "Flow",
        features: "Feature Code",
        queues: "Call Queue",
        "short-numbers": "Short Number",
        conduits: "Conduit",
        devices: "Phone",
        voicemails: "Voicemail"
      },
      recordNameField: {
        extensions: "name",
        "conference-bridges": "name",
        huntlists: "name",
        "paging-groups": "name",
        flows: "name",
        queues: "name",
        devices: "name",
        features: "comment",
        "short-numbers": "number",
        conduits: "prefix",
        voicemails: "fullName"
      }
    };
  },

  watch: {
    inUse: {
      immediate: true,
      handler(val) {
        if (val) {
          const { service, recordId } = val;
          feathersClient
            .service(service)
            .get(recordId)
            .then((res) => {
              this.record = res;
            });
        }
      }
    }
  },

  methods: {
    getServiceName() {
      return this.inUse && this.inUse.service
        ? this.serviceNames[this.inUse.service]
        : "";
    },

    getRecordName() {
      return this.record
        ? this.record[this.recordNameField[this.inUse.service]]
        : "";
    }
  }
};
</script>

<style></style>
